import { render } from "./ModalBuscarUsuario.vue?vue&type=template&id=5cf29442"
import script from "./ModalBuscarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalBuscarUsuario.vue?vue&type=script&lang=js"

import "./ModalBuscarUsuario.vue?vue&type=style&index=0&id=5cf29442&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__